var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('chrome-picker',{attrs:{"value":_vm.value},on:{"input":_vm.handleChangeColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }